import { RequestWebApi, validateRequestErrorStatus } from "./Requests";

const controller = "TipoVeiculo";
export const Listar = (tipoVeiculo) =>
  RequestWebApi.get(`/${controller}/Listar`, {
    params: { ...tipoVeiculo },
  })
    .then(function (response) {
      const { resultData, success } = response.data;
      const tiposVeiculo = resultData;
      return { success, tiposVeiculo };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      return { tiposVeiculo: [] };
    });

export const Detalhes = (tipoVeiculoId) =>
  RequestWebApi.get(`/${controller}/Detalhes`, {
    params: { tipoVeiculoId: tipoVeiculoId },
  })
    .then(function (response) {
      const { resultData, success } = response.data;
      const tipoVeiculo = resultData;
      return { success, tipoVeiculo };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      const { success, message, errors } = error.response.data;
      return { success, message, errors, tipoVeiculo: {} };
    });

export const Incluir = (tipoVeiculo) =>
  RequestWebApi.post(`/${controller}/Incluir`, tipoVeiculo)
    .then(function (response) {
      const { resultData, success } = response.data;
      const novoProduto = resultData;
      return { success, novoProduto };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      const { success, message, errors } = error.response.data;
      return { success, message, errors };
    });

export const Atualizar = (tipoVeiculo) =>
  RequestWebApi.put(`/${controller}/Atualizar`, tipoVeiculo)
    .then(function (response) {
      const { success } = response.data;
      return { success };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      const { success, message, errors } = error.response.data;
      return { success, message, errors };
    });

export const Remover = (tipoVeiculoId) =>
  RequestWebApi.delete(`/${controller}/Remover`, {
    params: { tipoVeiculoId: tipoVeiculoId },
  })
    .then(function (response) {
      const { success } = response.data;
      return { success };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      const { success, message, errors } = error.response.data;
      return { success, message, errors };
    });
